import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./styles/default.css?vue&type=style&index=0&lang=css&external"
import "./styles/pcd-i18n.css?vue&type=style&index=1&lang=css&external"
import "./App.vue?vue&type=style&index=2&id=2be9d287&lang=css"

const __exports__ = script;

export default __exports__